import { render, staticRenderFns } from "./gift_statistics.vue?vue&type=template&id=14e622d2&scoped=true"
import script from "./gift_statistics.vue?vue&type=script&lang=ts"
export * from "./gift_statistics.vue?vue&type=script&lang=ts"
import style0 from "./gift_statistics.vue?vue&type=style&index=0&id=14e622d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e622d2",
  null
  
)

export default component.exports